import React from "react";
import IFrame from "components/iframe";

const GenericIframe = ({ data }) => (
    <IFrame url={data.src} width={data?.width} height={data?.height} />
);

export default GenericIframe;
